export default __webpack_public_path__ + "static/media/020205202147100.52af09f3.png";